module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig1"
    }
  }, [_c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "600",
      "src": "images/chi-gunn-fig001-new.jpeg",
      "width": "502"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Figure 1.")]), _vm._v(" Artist Mitch O’Connell’s "), _c('i', [_vm._v("Alien Trump.")]), _vm._v(" Courtesy of Mitch O’Connell.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d951ff9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-gunn-0009.vue
// module id = 78
// module chunks = 0